import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import cookieBanner from '@tiktok-fe/web-cookie-banner';
import { TtWid } from '@byted-ucenter/ttwid/lib/pure';

/**
 * 初始化ttwid
 */
var initTtWid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var domainConfig, currentDomain, config, webId, checkResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // 根据当前域名选择相应的配置
            domainConfig = {
              'wj.tiktokv-us.com': {
                service: 'wj.tiktokv-us.com',
                unionHost: 'https://wj.tiktokv-us.com'
              }
            };
            currentDomain = window.location.hostname;
            config = domainConfig[currentDomain];
            if (config) {
              _context.next = 7;
              break;
            }
            console.log('Current domain is not supported for ttwid initialization');
            return _context.abrupt("return");
          case 7:
            webId = new TtWid({
              aid: 1424,
              // 业务自己的 Olympus appId
              service: config.service,
              // 业务域名
              unionHost: config.unionHost,
              // 业务域名
              union: true // 当前域名独享 ttwid
            }); // 先检查ttwid是否有效
            _context.next = 10;
            return webId.checkWebId();
          case 10:
            checkResult = _context.sent;
            if (!(!checkResult || checkResult.status_code === 1002 || checkResult.status_code === 1003)) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return webId.registerUnionWebId();
          case 14:
            console.log('ttwid initialized successfully');
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            console.error('Failed to initialize ttwid:', _context.t0);
            // ttwid失败不影响cookie banner的加载
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 17]]);
  }));
  return function initTtWid() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Cookie Banner背景：https://bytedance.larkoffice.com/wiki/LALSwec12ikhojkG7wAcCNdMnvh
 */
export var initCookieBanner = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var supportedDomains;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            supportedDomains = ['wj.tiktokv-us.com'];
            if (supportedDomains.includes(window.location.hostname)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return initTtWid();
          case 6:
            _context2.next = 8;
            return cookieBanner.loadCookieBanner({
              locale: 'en',
              apiDomain: "".concat(window.location.protocol, "//").concat(window.location.host),
              consentApiDomain: "".concat(window.location.protocol, "//").concat(window.location.host)
            });
          case 8:
            console.log('Cookie banner loaded successfully');
            _context2.next = 14;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            console.error('Failed to load cookie banner:', _context2.t0);
          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 11]]);
  }));
  return function initCookieBanner() {
    return _ref2.apply(this, arguments);
  };
}();
export default initCookieBanner;